import { LEARNING_TYPE_FILTER_SUBTITLE } from "../constants";
import { getFacetAttributeName } from "./getFacetAttributeName";

interface LearningTypeSubtitleProps {
  filterCategory: string;
  itemValue: string;
  indexName: string;
  className?: string;
}

export default function LearningTypeSubtitle({
  filterCategory,
  itemValue,
  indexName,
  className = "text-xs text-gray-700",
}: LearningTypeSubtitleProps) {
  const learningTypeFacet = getFacetAttributeName("learning_type", {
    indexName,
  });

  if (
    filterCategory !== learningTypeFacet ||
    !LEARNING_TYPE_FILTER_SUBTITLE[
      itemValue as keyof typeof LEARNING_TYPE_FILTER_SUBTITLE
    ]
  ) {
    return null;
  }

  return (
    <label className={className}>
      {
        LEARNING_TYPE_FILTER_SUBTITLE[
          itemValue as keyof typeof LEARNING_TYPE_FILTER_SUBTITLE
        ]
      }
    </label>
  );
}
